import React, { useEffect, useState } from 'react'
import classes from "../../styles.module.css";
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { FullWidthWiraaAds } from '../../../../common/Ads/FullWidthWiraaAds';
import TitleSection from '../../../../common/TitleSection';
import styles from "../../../../ContentStyling.module.css";

const CmToFeet = () => {
    const [inputValue, setInputValue] = useState();
    const [outputValue, setOutputValue] = useState();
    const [errorMessage, setErrorMessage] = useState();
    const navigate = useNavigate();

    useEffect(() => {
        // Initialize Google Ads
        try {
          (window.adsbygoogle = window.adsbygoogle || []).push({});
          console.error("AdSense run successfully");
        } catch (e) {
          console.error("AdSense error", e);
        }
      }, []);

      const convertCmToFeet = () => {
        // Validate input: allow numbers, decimals, and optional minus sign
        if (!/^-?\d+(\.\d+)?$/.test(inputValue)) {
            setErrorMessage("Please enter a valid length in centimeters (e.g., 150, 170.5).");
            setOutputValue("");
            return;
        }

        setErrorMessage("");
        const cmValue = parseFloat(inputValue); // Convert input string to a number
        const feetValue = cmValue / 30.48; // 1 foot = 30.48 cm
        setOutputValue(feetValue.toFixed(6)); // Limit output to 6 decimal places
    };

      const handleClearBtn = () => {
        setInputValue("");
        setOutputValue("");
        setErrorMessage("");
      }

      const handleSwapClick = () => {
        navigate("/converters/feet-to-cm");
    };

        

  return (
    <div className={classes.page}>
      <Helmet>
                <title>CM to Feet Converter - Wiraa tools</title>
                <meta name="description" content="Easily convert Cm to Feet using our online conversion tool. Accurate results with simple calculations for your length measurements. Try now!" />
        </Helmet>
    <div className={classes.container}>
       <TitleSection
          icon="https://cdn-icons-png.flaticon.com/128/570/570968.png"
          title="CM To Feet Converter"
          subTitle="Effortlessly Convert CM To Feet for Accurate Measurements"
        />
      <div className={classes.innerCon}>
        <div className={classes.inputCon}>
            <p className={classes.inputplaceholder}>CM Value</p>
            <input value={inputValue} onChange={(e) => setInputValue(e.target.value)} className={classes.inputfield} placeholder='Enter cm value'/>
            {errorMessage && <p className={classes.errorMsg}>{errorMessage}</p>}
        </div>
        <div className={classes.btnCon}>
            <button className={classes.convertBtn} onClick={convertCmToFeet}>Convert</button>
            <button className={classes.clearBtn} onClick={handleClearBtn}>Clear</button>
            <button className={classes.swapBtn} onClick={handleSwapClick}>Swap</button>
        </div>
        <div className={classes.outputCon}>
            <p className={classes.outputplaceholder}>Feet Value</p>
            <p className={classes.outputfield}>{outputValue}</p>
        </div>
      </div>
      <div className={classes.ads}>
        <FullWidthWiraaAds/>
     </div>
     <div className={styles.contentContainer}>
      <p>Converting centimetres to feet is an essential task across fields like design, architecture, construction, and everyday use. Since different countries and industries use different measurement systems (metric vs imperial), knowing how to convert cm to feet ensures accuracy and compatibility in your work.</p>
      <h3>What Are Centimeters and Feet?</h3>
      <p><b>Centimetre (cm): </b>A metric unit of length equal to one hundredth of a meter. Commonly used in most parts of the world for measuring height, length, or distance.</p>
      <p><b>Foot (ft): </b> An imperial unit of length used primarily in the United States, equal to 12 inches or approximately 30.48 centimeters. Often used in construction, interior design, and personal height measurements.</p>
      <h3>How to Convert CM to Feet</h3>
      <p>To convert centimeters to feet, follow these simple steps:</p>
      <p><b>1. Use the Conversion Factor:</b><br />1 foot = 30.48 centimeters</p>
      <p><b>Apply the Formula: </b><br />Divide the length in centimeters by 30.48 to get the value in feet.</p>
      <p><b>Formula:</b> <br /> Feet = Centimeters ÷ 30.48</p>
      <h3>Example Conversions</h3>
      <p><b>160 cm</b><br />Conversion: 160 ÷ 30.48 = 5.25 ft
      <br />(Often used for measuring human height.)</p>
      <p><b>250 cm</b><br />Conversion: 250 ÷ 30.48 = 8.2 ft <br />(Useful for ceiling height or furniture sizing.)</p>
      <p><b>100 cm</b><br />Conversion: 100 ÷ 30.48 = 3.28 ft</p>
      <h3>Benefits of Converting CM to Feet</h3>
      <ul>
        <li><b>International Communication:</b>Helps when working with clients or collaborators in countries using the imperial system.</li>
        <li><b>Design Accuracy:</b>Ensures that your measurements fit standards in architecture, fashion, or digital modeling where imperial units are required.</li>
        <li><b>Ease of Use in Construction:</b>Many tools and material specs (like wood, piping, and tiles) are in feet/inches, so conversions are key.</li>
      </ul>
      <h3>How to Use Feet in Your Projects</h3>
      <p>Once converted, you can represent feet in two common formats:</p>
      <ul>
        <li>
          <b>Decimal Format:</b><br />
          5.25 ft <br />
          (Often used in digital design or mathematical calculations.)
        </li>
        <li>
          <b>Feet and Inches Format:</b><br />
           5 ft 3 in <br />
           (To convert decimal feet to inches: take the decimal part and multiply by 12.) <br />
           Example: 0.25 × 12 = 3 → 5 ft 3 in
        </li>
      </ul>
      <h3>Why Use CM to Feet Conversion?</h3>
      <ul>
        <li><b>Flexibility:</b>Seamlessly move between metric and imperial units depending on client or project needs.</li>
        <li><b>Precision:</b>Allows for fine-tuned measurements in feet while keeping metric base references.</li>
        <li><b>Cross-Platform Consistency:</b> Whether you're designing in AutoCAD, SketchUp, or communicating specs in Excel, cm to feet ensures everyone’s on the same page.</li>
      </ul>
     </div>
    </div>
   </div>
  )
}

export default CmToFeet;
